import { status as PS } from '../../helpers/passport';
import { isAdmin, isStratAdmin, isProjectAdmin } from '../rolesSvc';

const isPortfolioAdmin = ({ mine }, portfolioId) => mine.portfolios && mine.portfolios.find((p) => p.portfId === parseInt(portfolioId) && (p.role === 'head' || p.role === 'admin'));

const rules = {
  Delete: {
    isStatusOk: (status) => [PS.draft, PS.returnedByPortf, PS.returnedByHeadSP, PS.returnedByExperts].includes(status),
    isRoleOk: (userCtx, stratId, projId) => isProjectAdmin(userCtx, projId) || isAdmin(userCtx),
  },
  Edit: {
    isStatusOk: (status) => status !== PS.expertsApproved,
    isRoleOk: (userCtx, stratId, projId, portfId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
    extra: (status, userCtx, stratId, projId, portfId) => isAdmin(userCtx) // ПО редактирует всегда, кроме "Одобрено ЭГ"
            || isStratAdmin(userCtx, stratId) && [PS.onApproveHeadSP].includes(status) // в статусе "На рассмотрении СП" редактировать может только СП
            || isPortfolioAdmin(userCtx, portfId) && [PS.onApprovePortf].includes(status) // в статусе "У руководителя портфеля" редактировать может только РПортф
            || (isPortfolioAdmin(userCtx, portfId) || isProjectAdmin(userCtx, projId)) && [PS.draft, PS.returnedByPortf, PS.returnedByHeadSP, PS.returnedByExperts, PS.approved, PS['-approved'], PS.expertsApproved].includes(status),
    // РП может редактировать на своих статусах и создавать новые версии + РПортф может делать всё то же самое вместо РП
  },
  EditCurrent: {
    isAnyVersion: true,
    isStatusOk: (status) => [PS.approved, PS['-approved'], PS.expertsApproved].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId) => isAdmin(userCtx),
  },
  EditCurrentMilestones: {
    isStatusOk: (status) => [PS.approved, PS['-approved'], PS.expertsApproved].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  SendToPortf: {
    isStatusOk: (status) => [PS.draft, PS.returnedByHeadSP, PS.returnedByExperts, PS.returnedByPortf].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx),
  },
  PortfReturn: {
    isStatusOk: (status) => PS.onApprovePortf === status,
    isRoleOk: (userCtx, stratId, projId, portfId) => isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx),
  },
  SendToHead: {
    isStatusOk: (status) => PS.onApprovePortf === status, // портфельные проекты отправляются РСП только со статуса "На согласовании руководителя портфеля"
    isRoleOk: (userCtx, stratId, projId, portfId) => isPortfolioAdmin(userCtx, portfId) || isAdmin(userCtx),
  },
  // у портфельных проектов РСП сразу одобряет проект (нет статуса рассмотрения ЭГ)
  // HeadSendToExperts: {
  //     isStatusOk: (status) => [PS.onApproveHeadSP].includes(status),
  //     isRoleOk: (userCtx, stratId, projId, portfId) => isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  // },
  HeadReturn: {
    isStatusOk: (status) => [PS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId) => isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  // соответственно, вернуть со статуса "На рассмотрении ЭГ" портфельный проект тоже нельзя
  // ExpertsReturn: {
  //     isStatusOk: (status) => [PS.onApproveExperts].includes(status),
  //     isRoleOk: (userCtx, stratId, projId, portfId) => isAdmin(userCtx),
  // },
  // одобряет проект РСП со своей стадии
  ExpertsApprove: {
    isStatusOk: (status) => [PS.onApproveHeadSP].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId) => isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  // отклонить совсем проект тоже нельзя
  // ExpertsDecline: {
  //     isStatusOk: (status) => [PS.onApproveExperts].includes(status),
  //     isRoleOk: (userCtx, stratId, projId, portfId) => isAdmin(userCtx),
  // },
  ApproveFinal: {
    isAnyVersion: true,
    isStatusOk: (status) => [PS.expertsApproved, PS.approved, PS['-approved'], PS.closed, PS.moved].includes(status),
    isRoleOk: (userCtx, stratId, projId, portfId) => isProjectAdmin(userCtx, projId) || isPortfolioAdmin(userCtx, portfId) || isStratAdmin(userCtx, stratId) || isAdmin(userCtx),
  },
  MoveProject: {
    isStatusOk: (status) => ![PS.closed, PS.moved].includes(status),
    isRoleOk: (userCtx) => isAdmin(userCtx)
  }
};

export const getActionsModel = (status, userCtx, stratId, projId, portfId, isLatestVersion) => Object.entries(rules).reduce((acc, [key, rule]) => ({
  ...acc,
  [key]: (isLatestVersion || rule.isAnyVersion)
    && rule.isStatusOk(status, isLatestVersion)
    && rule.isRoleOk(userCtx, stratId, projId, portfId)
    && (!rule.extra || rule.extra(status, userCtx, stratId, projId, portfId)),
}), {});
